import S from 's-js';

// Represent the browser's hash field as a signal
// changes when the hash changes, changes the hash when it is changed
export const HashSignal = () => {
    const _hash = S.data<string>(window.location.hash),
        onHashChange = (e : HashChangeEvent) => 
            _hash(window.location.hash),
        registration = S(() => { 
            // wrap event registration in a computation, so that it can be disposed
            window.addEventListener("hashchange", onHashChange);
            S.cleanup(() => window.removeEventListener("hashchange", onHashChange));
        }),
        hash = function (str? : string, inplace? : boolean) : string {
            registration(); // allows S.dispose(hash) to dispose the registration
            if (arguments.length === 0) return _hash();
            else {
                const hash = '#' + str!;
                if (inplace) window.location.replace(hash);
                else window.location.assign(hash);
                return str!;
            }
        };

    return hash;
}
export type HashSignal = ReturnType<typeof HashSignal>;



// WEBPACK FOOTER //
// ./lib/hashSignal.ts